export const ADD_INPUT = 'addInput'
export const DEL_INPUT = 'delInput'
export const UPDATE_LABEL = 'updLabel'
export const ADD_IMAGE = 'addImage'
export const SET_IMAGE = 'setImage'
// export const SET_AIDATA = 'setAidata'
export const DEL_IMAGE = 'delImage'
export const MANUAL_SW = 'manualSw'
export const SAMPLE_SW = 'sampleSw'
export const CAMERA_SW = 'cameraSw'
export const UPDATE_ACT = 'updAction'
export const DISP_MODAL_CHG = 'dispModalChg'
export const SET_KITIP = 'setKitIp'
export const SET_MESSAGE = 'setMessage'
export const SET_PROGBAR = 'setProgbar'
export const SET_TRAIN_DISABLE = 'setTrainDisable'
export const ADD_AIMODEL = 'addAimodel'
export const UPDATE_AIPARAM = 'updateAiparam'
export const DEL_AIMODEL = 'delAimodel'
export const SET_AIRESULT = 'setAiResult'
export const UPDATE_CONTKIT = 'updContkit'
export const SET_ALWAYSPRED = 'setAlwaysPredict'
export const SET_ACTCONF = 'setActConf'
export const ADD_ACTCONF = 'addActConf'
export const DEL_ACTCONF = 'delActConf'
export const SET_KITDATA = 'setKitdata'
export const LOAD_FILE = 'loadFile'



// WEBPACK FOOTER //
// ./src/mutation-types.js